// Selectors
export const SELECTOR_SUMMARY = '[data-accordion-title]';
const SELECTOR_CONTENT = '[data-accordion-body]';

export class AccordionSlide {
  public el: HTMLDetailsElement;
  public summary: HTMLElement|null;
  public content: HTMLElement|null;
  private animation: null|Animation;
  private isClosing: boolean;
  private isExpanding: boolean;
  private animationSpeed: number = 400;

  constructor(el:HTMLDetailsElement) {
    this.el = el;
    this.summary = el.querySelector(SELECTOR_SUMMARY);
    this.content = el.querySelector(SELECTOR_CONTENT);

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
  }

  public onClick(e:Event) {
    if(e) e.preventDefault();

    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  private shrink() {
    if(!this.summary) return;

    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: this.animationSpeed,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  private open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  private expand() {
    if(!this.summary || !this.content) return;

    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: this.animationSpeed,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  private onAnimationFinish(open:boolean) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}
